export default __webpack_public_path__ + "static/media/warning.02dfb8ad.svg";